"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NutritionFacts = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const NutritionWeekFact_1 = __importDefault(require("./NutritionWeekFact"));
const typography_1 = require("../../shared/typography");
const renderFacts = (translations) => {
    const elements = [];
    for (const translation in translations) {
        elements.push((0, jsx_runtime_1.jsx)(NutritionWeekFact_1.default, { value: (0, jsx_runtime_1.jsx)(typography_1.P, { children: translations[translation] }, void 0) }, translations[translation]));
    }
    return elements;
};
const NutritionFacts = (props) => {
    return ((0, jsx_runtime_1.jsx)(Wrapper, { children: (0, jsx_runtime_1.jsx)("div", { "data-cy": "nutrition-budget-facts-translations", children: renderFacts(props.translations) }, void 0) }, void 0));
};
exports.NutritionFacts = NutritionFacts;
const Wrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: ${({ theme }) => `0 ${theme.spacings.xl}`};

  & > div {
    display: flex;
  }

  & > div > div {
    margin-left: ${({ theme }) => theme.spacings.s};
    width: 75px;
  }

  p {
    color: ${({ theme }) => theme.colors.greyLighten40};
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 0;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    display: none;
  }
`;
//# sourceMappingURL=NutritionFacts.js.map